import { Fragment } from 'react'

import { GenericCarousel } from 'reactGarden/GenericCarousel'

import { useResize } from 'reactUtils/hooks/use-resize'

import { Icon } from 'lmcv/components/Icon'

import * as S from './styled'

const ITEMS = [
  {
    icon: 'coupon',
    title: 'Cupons de Desconto'
  },
  {
    icon: 'giftg',
    title: 'Surpresa de Aniversário'
  },
  {
    icon: 'calendarg',
    title: 'Eventos Especiais'
  },
  {
    icon: 'course',
    title: 'Cursos e Workshops'
  },
  {
    icon: 'content',
    title: 'Conteúdos Exclusivos'
  }
]

function Carousel () {
  const [isMobile] = useResize()

  const carouselProps = {
    slidesPerView: 'auto',
    spaceBetween: 64,
    centerInsufficientSlides: true,
    hasOffset: false
  }

  const renderIcons = () =>
    ITEMS.map(({ icon, title }, index) => {
      const lastItem = index === ITEMS.length - 1
      return (
        <S.Item key={title} hasDivider={!lastItem} isMobile={isMobile}>
          <S.Image>
            <Icon name={icon} fill="linear" />
          </S.Image>
          <S.Title align="center" size="kilo" noMargin>{title}</S.Title>
        </S.Item>
      )
    })

  return (
    <Fragment>
      {isMobile
        ? (<GenericCarousel {...carouselProps}>{renderIcons()}</GenericCarousel>)
        : (<S.List>{renderIcons()}</S.List>)
      }
    </Fragment>
  )
}

Carousel.propTypes = {}

export default Carousel
